<template>
  <CSidebar
    fixed
    :minimize="minimize"
    :show="show"
    @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none" to="/">
      <img src="/img/logo.webp" class="img-responsive logo"/>
    </CSidebarBrand>

    <CRenderFunction flat :content-to-render="navigationRoutes"/>
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
    />
  </CSidebar>
</template>

<script>
import updateNavigationRoutes from './_nav'

export default {
  name: 'TheSidebar',
  mounted: function () {
    updateNavigationRoutes()
  },
  computed: {
    navigationRoutes () {
      return this.$store.state.navigationRoutes
    },
    show () {
      return this.$store.state.sidebarShow
    },
    minimize () {
      return this.$store.state.sidebarMinimize
    }
  }
}
</script>
